export const initObject = {
  url: "https://swoosh-backend.onrender.com",
  // url: "http://localhost:8000",
};
